import { toast } from "sonner";
import i18n, { formatNumber } from "@/lib/i18n";
import { ApiError } from "./api";

/** Human-readable message for an API error. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const key = `errors.${err.code}`;
    if (i18n.exists(key)) {
      // Numbers in Swiss notation (31'204), like everywhere else in the app.
      const values = Object.fromEntries(
        Object.entries(err.details).map(([k, v]) => [k, typeof v === "number" ? formatNumber(v) : v]),
      );
      return i18n.t(key, values);
    }
    if (err.status === 403) return i18n.t("errors.forbidden");
  }
  return i18n.t("errors.generic");
}

export function toastError(err: unknown) {
  toast.error(errorMessage(err));
}

/** Field errors from a validation response, keyed by field path and translated. */
export function fieldErrors(err: unknown): Record<string, string> {
  if (!(err instanceof ApiError)) return {};
  const result: Record<string, string> = {};
  for (const issue of err.issues) {
    const key = `contacts.validation.${issue.message}`;
    result[issue.path] = i18n.exists(key) ? i18n.t(key) : issue.message;
  }
  return result;
}
